module.exports = __webpack_public_path__ + "static/media/AI.10fb360a.svg";